var sro = sro || {};
sro     = {
    init: function () {
        sro.fitToViewport();
        sro.hotspots.init();
        sro.deactivatePanning.init();
        sro.bindEvents();
    },
    bindEvents: function () {
        jQuery( window ).on( 'resize', e4.util.debounce( sro.fitToViewport ) );
        var jFooter = jQuery( '.js-e-footer' );
        jFooter.find( '.js-sro-footer-toggle-btn' ).on( 'click', function ( event ) {
            event.preventDefault();
            jFooter.toggleClass( 'is-open' );
        } );
    },
    fitToViewport: function () {
        
        if(sro.deactivatePanning.get() === false){
            sro.canvas.setHeight();
            sro.panzoom.setPosition();
        } else{
            jQuery('.js-sro-panzoom-element').removeAttr('style');
        }
        
        if ( sro.googleCharts.dataTable !== null ) {
            sro.footer.setPosition();
            sro.footer.setHeight();
            sro.googleCharts.draw();
        }
    },
    deactivatePanning: {
        init: function(){
            sro.deactivatePanning.setInput();
            sro.deactivatePanning.bindEvents();
        },
        bindEvents: function(){
            jQuery('.js-sro-panning-toggle-input').on('change', function(){
                sro.deactivatePanning.toggle();
            });
        },
        get: function () {
            var storedData = localStorage.getItem( 'sro.panning.deactivated' );
            return storedData !== null && storedData === 'true';
        },
        setInput: function () {
            var isPanningDeactivated = sro.deactivatePanning.get();
            jQuery('.js-sro-panning-toggle-input').prop('checked', isPanningDeactivated );
        },
        toggle: function () {
            var isPanningDeactivated = sro.deactivatePanning.get();
            localStorage.setItem( 'sro.panning.deactivated', (!isPanningDeactivated).toString() );
            location.reload();
        }
    },
    canvas: {
        setHeight: function () {
            var jWindow           = jQuery( window ),
                intViewportHeight = jWindow.height(),
                jCanvas           = jQuery( '.js-e-canvas' ),
                intCanvasHeight   = jCanvas.height();
            if ( intViewportHeight !== intCanvasHeight ) {
                jCanvas.height( intViewportHeight );
            }
        }
    },
    header: {},
    main: {
        init: function () {
        },
        adjustToFooter: function ( intFooterToggleContainerHeight ) {
            jQuery( '.js-e-content' ).css( 'margin-bottom', intFooterToggleContainerHeight );
        }
    },
    footer: {
        show: function () {
            sro.footer.setPosition();
            sro.footer.setHeight();
        },
        setHeight: function () {
            jQuery( '.js-e-footer' ).css( 'max-height', jQuery( window ).height() );
        },
        setPosition: function () {
            var jFooter                        = jQuery( '.js-e-footer' ),
                intFooterToggleContainerHeight = Math.floor( jFooter.find( '.js-sro-footer-toggle-container' ).outerHeight() );
            jFooter.css( 'transform', 'translateY(' + ( intFooterToggleContainerHeight ) * -1 + 'px)' );
            sro.main.adjustToFooter( intFooterToggleContainerHeight );
        }
    },
    hotspots: {
        data: {
            liveData: {},
            historicalData: [],
            mapData: {},
            iconData: {},
            reportsData: []
        },
        init: function () {
            if ( jQuery( '.js-sro-hotspots-container' ).length === 1 ) {
                sro.hotspots.data.mapData = window.sroMapData;
                jQuery.when.apply( jQuery, [
                    e4.util.require.js( e4.settings.require.handlebars ),
                    e4.util.require.js( e4.settings.require.moment ),
                    e4.util.require.js( e4.settings.require.datepicker ),
                    e4.util.require.js( e4.settings.require.jQueryValidate )
                ] ).then( function () {
                    google.charts.load( 'current', {
                        'packages': [
                            'line',
                            'corechart',
                            'gauge'
                        ],
                        'language': 'da'
                    } );
                    google.charts.setOnLoadCallback( function () {
                        sro.hotspots.handlebars.init();
                        sro.hotspots.report.init();
                        sro.hotspots.liveData.init();
                    } );
                } );
            }
        },
        handlebars: {
            init: function () {
                e4.handlebars.registerHelpers( 'compare' );
                sro.hotspots.handlebars.registerHelper();
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-sro-hotspots #js-e-handlebars-tmpl-sro-gauges #js-e-handlebars-tmpl-sro-hotspot-image #js-e-handlebars-tmpl-sro-key-figures #js-e-handlebars-tmpl-sro-reports' );
            },
            registerHelper: function () {
                Handlebars.registerHelper( 'renderContentScript', function ( id, text ) {
                    var domParser  = new DOMParser,
                        domElement = domParser.parseFromString( '<!doctype html><body>' + text, 'text/html' ),
                        parsedText = domElement.body.innerHTML;
                    //console.log(parsedText );
                    return '<script id="js-e-handlebars-tmpl-sro-data-box' + id + '" type="text/x-handlebars-template">' + parsedText + '</script>';
                } );
                Handlebars.registerHelper( 'testCondition', function ( val1, condition, val2, negate, options ) {
                    var dataTestValue = sro.hotspots.data.liveData[ val1 ];
                    if ( isNaN( val2 ) === false ) {
                        dataTestValue = e4.util.formatStringToJavascriptNumber( dataTestValue );
                        val2          = e4.util.formatStringToJavascriptNumber( val2 );
                    }
                    switch ( condition ) {
                        case '===':
                            return ( dataTestValue === val2 ) === !negate ? options.fn( this ) : options.inverse( this );
                        case '!==':
                            return ( dataTestValue !== val2 ) === !negate ? options.fn( this ) : options.inverse( this );
                        case '<':
                            return ( dataTestValue < val2 ) === !negate ? options.fn( this ) : options.inverse( this );
                        case '>':
                            return ( dataTestValue > val2 ) === !negate ? options.fn( this ) : options.inverse( this );
                        default:
                            return options.inverse( this );
                    }
                } );
                Handlebars.registerHelper( 'renderSvgCode', function ( svgPath, id ) {
                    if ( sro.hotspots.data.iconData[ id ] ) {
                        setTimeout( function () {
                            jQuery( '#js-sro-data-box-icon' + id ).html( jQuery( sro.hotspots.data.iconData[ id ] ).get( 0 ) );
                        }, 0.001 );
                    }
                    else {
                        jQuery.when( jQuery.ajax( svgPath ) ).then( function ( data ) {
                            var svg                          = jQuery( data ).find( 'svg' );
                            svg                              = svg.removeAttr( 'xmlns:a' );
                            sro.hotspots.data.iconData[ id ] = svg.prop( 'outerHTML' );
                            jQuery( '#js-sro-data-box-icon' + id ).html( svg );
                        } );
                    }
                } );
            }
        },
        ajax: function ( objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                url: '/system/data/sro-live-data',
                method: 'GET',
                dataType: 'json',
                cache: false
            }, objAjaxSettings ) );
            jqXHR.done( function ( data ) {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( data );
                }
            } );
        },
        report: {
            init: function () {
                sro.hotspots.report.bindEvents();
                sro.hotspots.report.getData( false, '' );
            },
            bindEvents: function () {
                jQuery( '.js-sro-reports-modal' ).on( 'click', '.js-sro-generate-report', function ( event ) {
                    var jForm = jQuery( event.target ).closest( 'form' );
                    if ( jForm.valid() === true ) {
                        sro.hotspots.report.generate( jForm );
                    }
                } ).on( 'click', '.js-sro-request-reports', function ( event ) {
                    var jForm = jQuery( event.target ).closest( 'form' );
                    if ( jForm.find( '.js-sro-request-reports-password' ).val() ) {
                        sro.hotspots.report.getData( true, jForm.find( '.js-sro-request-reports-password' ).val() );
                    }
                } ).on( 'keydown', 'form', function ( event ) {
                    if ( event.keyCode === 13 ) {
                        event.preventDefault();
                        jQuery( '.js-sro-reports-modal' ).find( '.js-sro-request-reports' ).trigger( 'click' );
                    }
                } ).on( 'change', '.js-sro-reports-period', function ( event ) {
                    var endDate = '-' + event.target.value + 'd';
                    jQuery( '.js-sro-reports-datepicker' ).datepicker( 'clearDates' ).datepicker( 'setEndDate', endDate );
                } );
            },
            getData: function ( boolLogin, strRequestReportsPassword ) {
                var pageid  = jQuery( '.js-sro-hotspots-container' ).data( 'pageId' ),
                    dataObj = {
                        pageid: pageid,
                        type: 'report'
                    };
                if ( boolLogin === true && strRequestReportsPassword !== '' ) {
                    dataObj.reportPassword = strRequestReportsPassword;
                }
                sro.hotspots.ajax( {
                    data: dataObj
                }, function ( data ) {
                    if ( data[ 0 ].counter > 0 ) {
                        sro.hotspots.data.reportsData = data[ 0 ];
                        sro.hotspots.report.buildReports();
                    }
                } );
            },
            datepicker: function () {
                jQuery.fn.datepicker.dates.da = e4.settings.custom.datepicker.dates.da;
                jQuery( '.js-sro-reports-datepicker' ).datepicker( {
                    format: 'dd-mm-yyyy',
                    language: 'da',
                    endDate: '-1d'
                } );
            },
            buildReports: function () {
                var reportsContainer = jQuery( '.js-sro-reports-container' );
                jQuery( '.js-e-nav-global' ).find( '.js-sro-reports-navigation' ).removeClass( 'd-none' );
                reportsContainer.html( e4.handlebars.tmpl.sroReports( sro.hotspots.data.reportsData ) );
                reportsContainer.find( 'form' ).validate();
                sro.hotspots.report.datepicker();
            },
            generate: function ( jForm ) {
                var selectedType   = jForm.find( '.js-sro-reports-type' ).filter( ':checked' ).val(),
                    selectedPeriod = jForm.find( '.js-sro-reports-period' ).filter( ':checked' ).val(),
                    selectedDate   = jForm.find( '.js-sro-reports-date' ).val(),
                    reportData     = sro.hotspots.data.reportsData.reports.filter( function ( row ) {
                        return row.reportItemId === selectedType;
                    } )[ 0 ];
                delete reportData.name;
                reportData.type     = selectedPeriod;
                reportData.fromDate = selectedDate.replace( /-/g, '' );
                jQuery( '.js-sro-reports-modal' ).modal( 'hide' );
                var reportGenerationUrlWithParams = '';
                for ( var key in reportData ) {
                    if ( reportGenerationUrlWithParams !== '' ) {
                        reportGenerationUrlWithParams += '&';
                    }
                    else {
                        reportGenerationUrlWithParams += e4.settings.custom.hotspots.reportGenerationUrl + '?';
                    }
                    reportGenerationUrlWithParams += key + '=' + encodeURIComponent( reportData[ key ] );
                }
                sro.hotspots.report.send( reportGenerationUrlWithParams );
            },
            send: function ( reportGenerationUrlWithParams ) {
                jQuery( '.js-e-page-loading-overlay' ).addClass( 'is-loading' );
                document.location.href = reportGenerationUrlWithParams;
                var generationListener = setInterval( function () {
                    var currentCookie = document.cookie;
                    if ( currentCookie.indexOf( 'generateCookie' ) > -1 ) {
                        clearInterval( generationListener );
                        document.cookie = 'generateCookie' + '=; Max-Age=0';
                        jQuery( '.js-e-page-loading-overlay' ).removeClass( 'is-loading' );
                    }
                }, 100 );
            }
        },
        historicalData: {
            init: function () {
                sro.hotspots.historicalData.load(true);
                setInterval(function(){
                    sro.hotspots.historicalData.load(false);
                }, e4.settings.custom.hotspots.liveUpdateInterval);
                
            },
            getRange: function () {
                var selectedValue = jQuery( '.js-sro-chart-range' ).val();
                return e4.settings.custom.hotspots.range[ selectedValue ];
            },
            load: function (boolFirstLoad) {
                var pageid = jQuery( '.js-sro-hotspots-container' ).data( 'pageId' ),
                    range  = sro.hotspots.historicalData.getRange(),
                    date   = moment().subtract( range.duration, range.key ).format( 'YYYY-MM-DD HH:mm:ss' );
                sro.hotspots.ajax( {
                    beforeSend: function () {
                        if(boolFirstLoad === true){
                            jQuery( '.js-e-sro-key-figures-loading-overlay' ).addClass( 'is-loading' );
                        }
                    },
                    data: {
                        pageid: pageid,
                        type: 'historical',
                        date: date
                    }
                }, function ( data ) {
                    sro.hotspots.data.historicalData = data;
                    if ( sro.hotspots.data.historicalData[ 0 ].content.length > 0 ) {
                        var arrActiveFigures = [ 0 ];
                        if ( sro.googleCharts.loaded === true ) {
                            arrActiveFigures = sro.googleCharts.getActiveFigures();
                        }
                        sro.hotspots.historicalData.handleData( arrActiveFigures );
                    }
                } );
            },
            build: {
                columns: function ( arrActiveFigures ) {
                    var contentObj = sro.hotspots.data.historicalData[ 0 ].content,
                        arrColumns = [];
                    arrColumns.push( [
                        'datetime',
                        'Dato'
                    ] );
                    for ( var i = 0; i < arrActiveFigures.length; i++ ) {
                        arrColumns.push( [
                            'number',
                            contentObj[ arrActiveFigures[ i ] ].title,
                            contentObj[ arrActiveFigures[ i ] ].units,
                            contentObj[ arrActiveFigures[ i ] ].axisTitle
                        ] );
                    }
                    return arrColumns;
                },
                rows: function ( arrActiveFigures ) {
                    var contentObj = sro.hotspots.data.historicalData[ 0 ].content,
                        dataObj    = sro.hotspots.data.historicalData[ 0 ].data,
                        arrRows    = [];
                    jQuery.each( dataObj, function ( index, entry ) {
                        var unixTimestamp = moment( entry.TimeStamp, 'DD-MM-YYYY HH:mm:ss' ).unix(),
                            timestamp     = new Date(),
                            arrRow        = [];
                        timestamp.setTime( unixTimestamp * 1000 );
                        arrRow.push( timestamp );
                        for ( var i = 0; i < arrActiveFigures.length; i++ ) {
                            arrRow.push( {
                                v: e4.util.formatStringToJavascriptNumber( entry[ contentObj[ arrActiveFigures[ i ] ].column ] ),
                                f: entry[ contentObj[ arrActiveFigures[ i ] ].column ].toString() + ' ' + contentObj[ arrActiveFigures[ i ] ].units
                            } );
                        }
                        arrRows.push( arrRow );
                    } );
                    return arrRows;
                },
                footerItems: function () {
                    var footerItems = [];
                    var arrActiveFigures = sro.googleCharts.getActiveFigures();
                    if(arrActiveFigures.length === 0){
                        arrActiveFigures.push(0);
                    }
                    sro.hotspots.data.historicalData[ 0 ].content.forEach( function ( entry, index ) {
                        footerItems.push( {
                            title: entry.title,
                            units: entry.units,
                            column: entry.column,
                            liveValue: sro.hotspots.data.liveData[ entry.column ],
                            color: e4.settings.custom.hotspots.colors[ index ],
                            isActive: jQuery.inArray(index, arrActiveFigures) > -1
                        } );
                    } );
                    return footerItems;
                }
            },
            handleData: function ( arrActiveFigures ) {
                sro.hotspots.data.footerItems = sro.hotspots.historicalData.build.footerItems();
                sro.hotspots.data.footerData  = {
                    columns: sro.hotspots.historicalData.build.columns( arrActiveFigures ),
                    rows: sro.hotspots.historicalData.build.rows( arrActiveFigures )
                };
                if ( sro.googleCharts.loaded === false ) {
                    sro.footer.show();
                    sro.googleCharts.init();
                }
                else {
                    sro.googleCharts.update();
                    sro.googleCharts.buildFooter();
                }
                jQuery( '.js-e-sro-key-figures-loading-overlay' ).removeClass( 'is-loading' );
            }
        },
        liveData: {
            interval: null,
            init: function () {
                sro.hotspots.liveData.load( sro.hotspots.build );
                sro.hotspots.liveData.bindInterval();
            },
            bindInterval: function () {
                sro.hotspots.liveData.interval = setInterval( function () {
                    sro.hotspots.liveData.load( sro.hotspots.update );
                }, e4.settings.custom.hotspots.liveUpdateInterval );
            },
            load: function ( callback ) {
                var pageid = jQuery( '.js-sro-hotspots-container' ).data( 'pageId' );
                sro.hotspots.ajax( {
                    data: {
                        pageid: pageid,
                        type: 'live'
                    }
                }, function ( data ) {
                    sro.hotspots.data.liveData = data[ 0 ];
                    if ( typeof callback === 'function' ) {
                        callback();
                    }
                } );
            }
        },
        build: function () {
            var dataObj = {
                hotspots: [],
                gauges: []
            };
            sro.hotspots.data.mapData.hotspots.forEach( function ( objHotspot ) {
                if ( objHotspot.gauge !== undefined && objHotspot.gauge.active === true ) {
                    dataObj.gauges.push( objHotspot );
                }
                else {
                    dataObj.hotspots.push( objHotspot );
                }
            } );
            sro.hotspots.data.mapData.hotspots = dataObj.hotspots;
            sro.hotspots.data.mapData.gauges   = dataObj.gauges;
            jQuery( '.js-sro-hotspots-boxes-container' ).html( e4.handlebars.tmpl.sroHotspots( sro.hotspots.data ) );
            jQuery( '.js-sro-hotspots-gauges-container' ).html( e4.handlebars.tmpl.sroGauges( sro.hotspots.data ) );
            if(sro.deactivatePanning.get() === false){
                jQuery( '.js-sro-hotspot-image-container' )
                        .html( e4.handlebars.tmpl.sroHotspotImage( sro.hotspots.data ) )
                        .find( '.js-sro-img' ).on( 'load', sro.panzoom.init );
            } else{
                jQuery( '.js-sro-hotspot-image-container' )
                        .html( e4.handlebars.tmpl.sroHotspotImage( sro.hotspots.data ) );
                jQuery('.js-sro-panzoom-container').addClass('has-deactivated-panzoom')
                e4.loading.resolveWait( '.js-sro-hotspots-container' );
            }
            
            sro.hotspots.registerInlineTemplates();
            sro.hotspots.historicalData.init();
            sro.googleCharts.gauges.init();
        },
        update: function () {
            jQuery( '.js-sro-hotspots-boxes-container' ).html( e4.handlebars.tmpl.sroHotspots( sro.hotspots.data ) );
            sro.hotspots.registerInlineTemplates();
            sro.googleCharts.gauges.update();
        },
        registerInlineTemplates: function () {
            jQuery( '.js-sro-hotspots-container' ).find( '.js-sro-data-box' ).each( function () {
                var hotspotId  = jQuery( this ).attr( 'id' ),
                    templateId = jQuery.camelCase( hotspotId );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-' + hotspotId );
                sro.hotspots.compileInlineTemplates( hotspotId, templateId );
            } );
        },
        compileInlineTemplates: function ( hotspotId, templateId ) {
            var compiledInlineTpl = e4.handlebars.tmpl[ templateId ]( sro.hotspots.data.liveData ),
                dataBox           = jQuery( '.js-sro-data-box[id="' + hotspotId + '"]' );
            dataBox.find( '.js-sro-data-box-inline-container' ).html( compiledInlineTpl );
        }
    },
    panzoom: {
        instance: null,
        init: function () {
            sro.panzoom.setImageSize();
        },
        setup: function () {
            var domPanzoomElement     = document.querySelector( '.js-sro-panzoom-element' ),
                objPanzoomElementRect = domPanzoomElement.getBoundingClientRect(),
                jPanzoomElement       = jQuery( domPanzoomElement );
            jPanzoomElement.data( {
                height: Math.round( objPanzoomElementRect.bottom - objPanzoomElementRect.top ),
                width: Math.round( objPanzoomElementRect.right - objPanzoomElementRect.left )
            } );
            sro.panzoom.instance = panzoom( domPanzoomElement, {
                maxZoom: 2,
                minZoom: sro.panzoom.getMinZoom(),
                bounds: true,
                boundsPadding: 0,
                boundsDisabledForZoom: true,
                onTouch: function ( event ) {
                    // `e` - is current touch event.
                    var objEvent              = jQuery.Event( event ),
                        jEventTarget          = jQuery( objEvent.target ),
                        jEventTargetBlockLink = jEventTarget.closest( '.js-e-block-link' ).length === 1;
                    if ( jEventTargetBlockLink.length === 1 ) {
                        jEventTargetBlockLink.trigger( 'click' );
                    }
                }
            } );
            sro.panzoom.setPosition();
            sro.panzoom.disableNativeZoom();
        },
        setImageSize: function () {
            var jImage = jQuery( '.js-sro-img' );
            if ( jImage.get( 0 ) !== undefined ) {
                var intImageWidth  = jImage.get( 0 ).naturalWidth,
                    intImageHeight = jImage.get( 0 ).naturalHeight;
                jQuery( '.js-sro-panzoom-element' ).css( {
                    width: intImageWidth,
                    height: intImageHeight
                } );
                e4.loading.resolveWait( '.js-sro-hotspots-container' );
                sro.panzoom.setup();
            }
        },
        setPosition: function () {
            if ( sro.panzoom.instance !== null ) {
                var intMinZoom = sro.panzoom.getMinZoom();
                sro.panzoom.instance.setMinZoom( intMinZoom );
                sro.panzoom.instance.zoomAbs( 0, 0, intMinZoom );
                sro.panzoom.instance.moveTo( 0, 0 );
            }
        },
        getMinZoom: function () {
            var domPanzoomContainer     = document.querySelector( '.js-sro-panzoom-container' ),
                objPanzoomContainerRect = domPanzoomContainer.getBoundingClientRect(),
                objPanzoomElementData   = jQuery( '.js-sro-panzoom-element' ).data(),
                intZoomRatioX           = Math.ceil( ( objPanzoomContainerRect.right - objPanzoomContainerRect.left ) ) / ( objPanzoomElementData.width ),
                intZoomRatioY           = Math.ceil( ( objPanzoomContainerRect.bottom - objPanzoomContainerRect.top ) ) / ( objPanzoomElementData.height ),
                intReturnValue          = Math.ceil( Math.max( intZoomRatioX, intZoomRatioY ) * 1000 ) / 1000;
            return intReturnValue;
        },
        disableNativeZoom: function () {
            // Stolen from https://github.com/lazd/iNoBounce/
            var boolSupportsPassiveOption = false;
            try {
                var objOptions = Object.defineProperty( {}, 'passive', {
                    get: function () {
                        boolSupportsPassiveOption = true;
                    }
                } );
                window.addEventListener( 'test', null, objOptions );
            }
            catch ( e ) {
            }
            var fnHandleTouchmove = function ( event ) {
                var zoom = window.innerWidth / window.document.documentElement.clientWidth;
                if ( event.touches.length > 1 || zoom !== 1 ) {
                    event.preventDefault();
                }
            };
            window.addEventListener( 'touchmove', fnHandleTouchmove, boolSupportsPassiveOption === true ? { passive: false } : false );
        }
    },
    googleCharts: {
        addedUnits: [],
        gaugeInstances: {},
        loaded: false,
        options: {},
        dataTable: null,
        chart: null,
        init: function () {
            sro.googleCharts.loaded = true;
            sro.googleCharts.chart  = new google.visualization.LineChart( document.getElementById( 'js-sro-charts' ) );
            sro.googleCharts.buildFooter();
            sro.googleCharts.bindEvents();
            sro.googleCharts.update();
        },
        gauges: {
            init: function () {
                sro.hotspots.data.mapData.gauges.forEach( function ( objGauge ) {
                    var gaugeLabelValue = [
                            [
                                'Labal',
                                'Value'
                            ],
                            [
                                objGauge.gauge.units,
                                e4.util.formatStringToJavascriptNumber( sro.hotspots.data.liveData[ objGauge.gauge.key ] )
                            ]
                        ],
                        domElm          = document.getElementById( 'js-gauge-' + objGauge.id ),
                        domContainer    = domElm.querySelector( '.js-sro-gauge-chart-container' ),
                        domLoader       = domElm.querySelector( '.js-gauge-loader' ),
                        dataTable       = google.visualization.arrayToDataTable( gaugeLabelValue ),
                        googleChart     = new google.visualization.Gauge( domContainer ),
                        objOptions      = sro.googleCharts.gauges.getOptions( objGauge );
                    sro.googleCharts.gauges.setInstance( objGauge.gauge.key, {
                        chart: googleChart,
                        data: dataTable,
                        options: objOptions
                    } );
                    domElm.removeChild( domLoader );
                    sro.googleCharts.gauges.draw( googleChart, dataTable, objOptions );
                } );
            },
            getOptions: function ( objGauge ) {
                var majorTicksDefault = [
                    objGauge.gauge.min.toString(),
                    objGauge.gauge.max.toString()
                ];
                return {
                    min: e4.util.formatStringToJavascriptNumber( objGauge.gauge.min ),
                    max: e4.util.formatStringToJavascriptNumber( objGauge.gauge.max ),
                    redColor: objGauge.gauge.redColor,
                    redFrom: objGauge.gauge.showRed ? e4.util.formatStringToJavascriptNumber( objGauge.gauge.min ) : '',
                    redTo: objGauge.gauge.showRed ? 0 : '',
                    width: objGauge.width_px,
                    minorTicks: objGauge.gauge.minorTicks,
                    majorTicks: objGauge.gauge.majorTicks !== '' ? objGauge.gauge.majorTicks.split( ',' ) : majorTicksDefault
                }
            },
            setInstance: function ( key, objGaugeData ) {
                sro.googleCharts.gaugeInstances[ key ] = objGaugeData;
            },
            update: function () {
                Object.keys( sro.googleCharts.gaugeInstances ).forEach( function ( gaugeChartKey ) {
                    var updatedValue = sro.hotspots.data.liveData[ gaugeChartKey ],
                        instance     = sro.googleCharts.gaugeInstances[ gaugeChartKey ],
                        googleChart  = instance.chart,
                        dataTable    = instance.data,
                        objOptions   = instance.options;
                    dataTable.setValue( 0, 1, e4.util.formatStringToJavascriptNumber( updatedValue ) );
                    sro.googleCharts.gauges.setInstance( gaugeChartKey, {
                        chart: googleChart,
                        data: dataTable,
                        options: objOptions
                    } );
                    sro.googleCharts.gauges.draw( googleChart, dataTable, objOptions );
                } );
            },
            draw: function ( googleChart, dataTable, objOptions ) {
                var formatNumbers = new google.visualization.NumberFormat( {
                    fractionDigits: 1
                } );
                formatNumbers.format( dataTable, 1 );
                googleChart.draw( dataTable, objOptions );
            }
        },
        bindEvents: function () {
            jQuery( '.js-e-footer' ).on( 'click', '.js-sro-key-figure', function ( event ) {
                sro.googleCharts.setActive( event.currentTarget );
            } ).on( 'change', '.js-sro-chart-range', function () {
                sro.hotspots.historicalData.load();
            } );
        },
        buildFooter: function () {
            
            jQuery( '.js-sro-key-figures' ).html( e4.handlebars.tmpl.sroKeyFigures( sro.hotspots.data.footerItems ) );
        },
        getActiveFigures: function () {
            return jQuery( '.js-e-footer' ).find( '.js-sro-key-figure.is-active' ).map( function ( index, domElm ) {
                return jQuery( domElm ).data( 'index' );
            } ).toArray();
        },
        getColors: function () {
            return jQuery( '.js-e-footer' ).find( '.js-sro-key-figure.is-active' ).map( function ( index, domElm ) {
                return jQuery( domElm ).data( 'color' );
            } ).toArray();
        },
        setActive: function ( domElm ) {
            var arrActiveFigures = sro.googleCharts.getActiveFigures();
            if ( arrActiveFigures.length < 2 ) {
                jQuery( domElm ).addClass( 'is-active' );
            }
            else {
                jQuery( domElm ).removeClass( 'is-active' );
            }
            arrActiveFigures = sro.googleCharts.getActiveFigures();
            if ( arrActiveFigures.length > 0 ) {
                sro.hotspots.historicalData.handleData( arrActiveFigures );
            }
            else {
                jQuery( domElm ).addClass( 'is-active' );
            }
        },
        update: function () {
            var series                 = {},
                vAxes                  = {};
            sro.googleCharts.dataTable = new google.visualization.DataTable();
            sro.hotspots.data.footerData.columns.forEach( function ( column, index ) {
                var strColumnType      = column[ 0 ],
                    strColumnValue     = column[ 1 ],
                    strColumnUnits     = column[ 2 ],
                    strColumnAxisTitle = column[ 3 ],
                    arrSelectedColors  = sro.googleCharts.getColors();
                sro.googleCharts.dataTable.addColumn( strColumnType, strColumnValue );
                if ( strColumnType !== 'datetime' ) {
                    var intColumnPosition       = ( index - 1 ) >= 1 ? 1 : 0,
                        axisTitle               = strColumnAxisTitle === '' ? strColumnUnits : strColumnAxisTitle;
                    series[ intColumnPosition ] = { targetAxisIndex: intColumnPosition };
                    vAxes[ intColumnPosition ]  = {
                        title: axisTitle,
                        titleTextStyle: { color: arrSelectedColors[ ( index - 1 ) ] },
                        textStyle: { color: arrSelectedColors[ ( index - 1 ) ] }
                    };
                }
            } );
            sro.hotspots.data.footerData.rows.forEach( function ( row ) {
                sro.googleCharts.dataTable.addRow( row );
            } );
            sro.googleCharts.options = sro.googleCharts.setOptions( series, vAxes );
            sro.googleCharts.draw();
        },
        setOptions: function ( series, vAxes ) {
            return {
                colors: sro.googleCharts.getColors(),
                animation: {
                    startup: true,
                    duration: 200,
                    easing: 'out'
                },
                legend: { position: 'top' },
                series: series,
                vAxes: vAxes,
                hAxis: {
                    textPosition: 'out'
                },
                vAxis: {
                    textPosition: 'out'
                }
            };
        },
        draw: function () {
            sro.googleCharts.chart.draw( sro.googleCharts.dataTable, sro.googleCharts.options );
        }
    }
};

